import React, { FunctionComponent } from 'react';
import { Flex, Box, Image } from '@rebass/emotion';
import {
  Wrapper,
  MainContent,
  ContentGrid,
  contentGridWidth,
  contentGridPadding,
} from './SeamlessElement2ColGrid.style';

import { SeamlessElementsQuery_seamlessSection_elements_SeamlessElement2ColGrid as SeamlessElement2ColGridProps } from '../SeamlessSection/__generated__/SeamlessElementsQuery';

const SeamlessElement2ColGrid: FunctionComponent<SeamlessElement2ColGridProps> = ({
  image,
  imageLeft,
  imageRight,
  content,
  contentLeft,
  contentRight,
  background,
}) => {
  return (
    <Box
      backgroundColor={background}
      py={4}
      data-testid="seamless-element-2col-grid"
    >
      <Wrapper px={2} width={['100%', '80%']}>
        <MainContent mb={5}>
          {content && <Box dangerouslySetInnerHTML={{ __html: content }} />}
          {image && <Image src={image} />}
        </MainContent>
        <Flex flexWrap="wrap" justifyContent="space-between">
          {contentLeft && (
            <ContentGrid px={contentGridPadding} width={contentGridWidth}>
              {imageLeft && <Image src={imageLeft} />}
              <Box my={3} dangerouslySetInnerHTML={{ __html: contentLeft }} />
            </ContentGrid>
          )}
          {contentRight && (
            <ContentGrid px={contentGridPadding} width={contentGridWidth}>
              {imageRight && <Image src={imageRight} />}
              <Box my={3} dangerouslySetInnerHTML={{ __html: contentRight }} />
            </ContentGrid>
          )}
        </Flex>
      </Wrapper>
    </Box>
  );
};

export default SeamlessElement2ColGrid;
